import { Card, CardContent, Typography, Button, Stack } from '@mui/material';

export function InsightsActions() {
  return (
    <Card sx={{ borderRadius: 3, mt: 4 }}>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Actions prioritaires
        </Typography>

        <Stack spacing={2}>
          <Button variant="contained">
            🚀 Créer un événement optimisé
          </Button>
          <Button variant="outlined">
            🎯 Lancer une campagne marketing
          </Button>
          <Button variant="outlined">
            📊 Explorer les performances
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
